export const GET_ALL_CATEGORY_REQUEST = "GET_ALL_CATEGORY_REQUEST";
export const GET_ALL_CATEGORY_FAILURE = "GET_ALL_CATEGORY_FAILURE";
export const GET_ALL_CATEGORY_SUCCESS = "GET_ALL_CATEGORY_SUCCESS";

export const CREATE_CATEGORY_REQUEST = "CREATE_CATEGORY_REQUEST";
export const CREATE_CATEGORY_FAILURE = "CREATE_CATEGORY_FAILURE";
export const CREATE_CATEGORY_SUCCESS = "CREATE_CATEGORY_SUCCESS";

export const UPDATE_CATEGORY_REQUEST = "UPDATE_CATEGORY_REQUEST";
export const UPDATE_CATEGORY_FAILURE = "UPDATE_CATEGORY_FAILURE";
export const UPDATE_CATEGORY_SUCCESS = "UPDATE_CATEGORY_SUCCESS";

export const DELETE_CATEGORY_REQUEST = "DELETE_CATEGORY_REQUEST";
export const DELETE_CATEGORY_FAILURE = "DELETE_CATEGORY_FAILURE";
export const DELETE_CATEGORY_SUCCESS = "DELETE_CATEGORY_SUCCESS";

export const CREATE_CATEGORY_BANNER_REQUEST = "CREATE_CATEGORY_BANNER_REQUEST";
export const CREATE_CATEGORY_BANNER_FAILURE = "CREATE_CATEGORY_BANNER_FAILURE";
export const CREATE_CATEGORY_BANNER_SUCCESS = "CREATE_CATEGORY_BANNER_SUCCESS";

export const UPDATE_CATEGORY_BANNER_REQUEST = "UPDATE_CATEGORY_BANNER_REQUEST";
export const UPDATE_CATEGORY_BANNER_FAILURE = "UPDATE_CATEGORY_BANNER_FAILURE";
export const UPDATE_CATEGORY_BANNER_SUCCESS = "UPDATE_CATEGORY_BANNER_SUCCESS";